<script setup>
import { storeToRefs } from "pinia";

const homeStore = useHomeStore();
const entriesStore = useEntriesStore();
const { current, seoTitle, seoDescription, seoImage, title } =
  storeToRefs(homeStore);
const { activeId, list } = storeToRefs(entriesStore);

const { $getHome } = useNuxtApp();
const config = useRuntimeConfig();
const constants = useConstants();
const route = useRoute();

const data = reactive({
  pageType: "",
});

const response = await $fetch("/api/home/");
homeStore.setCurrent(response.data[0]);
entriesStore.setCurrent(null);
entriesStore.setList(response.data[0]?.grid);

definePageMeta({
  layout: "default",
});
useHead({
  title: (seoTitle?.value ?? title?.value ?? "") + constants.app.title,
  link: [
    {
      rel: "canonical",
      href: config.public.appBaseUrl ?? null,
    },
  ],
});
useSeoMeta({
  title: (seoTitle?.value ?? title?.value ?? "") + constants.app.title,
  description: seoDescription?.value ?? null,
  image: seoImage?.value ?? null,
  ogSiteName: constants.app.siteName,
  ogType: "website",
  ogTitle: (seoTitle?.value ?? title?.value ?? "") + constants.app.title,
  ogDescription: seoDescription?.value ?? null,
  ogImage: seoImage?.value ?? null,
  ogUrl: config.public.appBaseUrl ?? null,
  ogArticlePublisher: constants.app.social.facebook,
  twitterTitle: (seoTitle?.value ?? title?.value ?? "") + constants.app.title,
  twitterDescription: seoDescription?.value ?? null,
  twitterImage: seoImage?.value ?? null,
});
</script>
<template>
  <NuxtPage v-if="current" />
  <Hero
    v-if="current"
    :title="current.titlePage"
    :text="current.text"
    :pageType="data.pageType"
  />
  <Grid :grid="list" :activeId="activeId" />
  <Blocks :blocks="current.blocks" />
</template>
